module.exports = __webpack_public_path__ + "static/media/sump.62c112d6.jpg";